import React, { useState, useEffect } from 'react';
export default function FootballBadge({src,name='',className='team-logo'}) {
  const [failed,setFailed]=useState(false);
  useEffect(()=>setFailed(false),[src]);
  return src && !failed ? <img src={src} alt="" className={className} onError={()=>setFailed(true)} /> : <span className={`${className} football-badge-fallback`} aria-label={name}>{name.split(/\s+/).filter(Boolean).slice(0,2).map(word=>word[0]).join('')}</span>;
}
